import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMetoroConfig } from '../hooks/useMetoroConfig';

interface MinimalFeatureGuardProps {
    children: React.ReactNode;
    allowedPaths: string[];
}

const MinimalFeatureGuard = ({ children, allowedPaths }: MinimalFeatureGuardProps) => {
    const { config } = useMetoroConfig();
    const location = useLocation();
    const currentPath = location.pathname;

    // If not in minimal mode, allow all access
    if (!config.isMinimal) {
        return <>{children}</>;
    }

    // In minimal mode with logs enabled
    if (config.minimalMetoroConfig?.enableLogs) {
        // For other paths, check if they are allowed
        if (allowedPaths.some(path => currentPath.startsWith(path))) {
            return <>{children}</>;
        } else {
            // Redirect to home if not allowed
            return <Navigate to="/home" replace />;
        }
    }

    // In minimal mode but logs not enabled, redirect to home
    return <Navigate to="/home" replace />;
};

export default MinimalFeatureGuard; 